import * as React from 'react';

import { TOffer } from '../../../types/offer';

export const usePreviewImage = (offer: TOffer | null): string => {
  return React.useMemo(() => {
    if (offer && offer.photos?.length) {
      return (offer.photos.find(p => p.isDefault) || offer.photos[0])?.miniUrl;
    }

    return '';
  }, [offer]);
};
